import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Toast } from '../../../types';
import { publishMyAbout } from '../member/thunk';

type State = {
  isPublicProfilePreview: boolean;
  toast: {
    isVisible: boolean;
    type: Toast;
  };
};

const initialState: State = {
  isPublicProfilePreview: false,
  toast: {
    isVisible: false,
    type: Toast.None,
  },
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsPublicProfilePreview(state, { payload }: PayloadAction<boolean>) {
      state.isPublicProfilePreview = payload;
    },
    hideToast(state) {
      state.toast.type = Toast.None;
      state.toast.isVisible = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(publishMyAbout.fulfilled, (state) => {
      state.toast.type = Toast.AboutPublish;
      state.toast.isVisible = true;
    });
  },
});

export const { setIsPublicProfilePreview } = uiSlice.actions;
